<template>
    <div>
        <v-toolbar dense>
            <v-app-bar-nav-icon v-on:click="updateDrawer"></v-app-bar-nav-icon>

            <v-toolbar-title v-on:click="goToHome">
                <v-img width="40"
                    :src="($vuetify.theme.dark) ? require('../assets/white-logo.svg') : require('../assets/black-logo.svg')">
                </v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-item>
                £{{
                        parseFloat(getAccountBalance.balance).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g,
                            ",")
                }}</v-item>

            <v-spacer></v-spacer>
            <!-- <v-btn icon v-on:click="goToTakePayment" v-if="enableQrcode">
                <v-icon :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'">mdi-barcode-scan</v-icon>
            </v-btn> -->


            <v-btn icon v-on:click="goToNotifications" v-if="enableNotifications">
                <span v-if="getUnreadMessages" class="counter"
                    :class="($vuetify.theme.dark) ? 'darkCounterBackground' : 'lightCounterBackground'">{{
                            getUnreadMessages.length
                    }}</span>
                <v-icon>mdi-bell</v-icon>
            </v-btn>


            <v-btn icon v-on:click="goToMyaccount">
                <v-icon>mdi-account</v-icon>
            </v-btn>

            <v-btn icon id="mode-switcher" v-on:click="switchMode">
                <v-icon>
                    {{ ($vuetify.theme.dark) ? 'mdi-weather-night' : 'mdi-weather-sunny' }}
                </v-icon>
            </v-btn>
        </v-toolbar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: "navBar",
    components: {

    },
    props: {
    },
    data: () => ({
        enableNotifications: false,
        enableQrcode: false,
    }),
    mounted() {

    },
    computed:
        mapGetters([
            'getAccount',
            'accountSettings',
            'getAccountBalance',
            'getIsLoadingAccountBalance',
            'getUnreadMessages'
        ]),
    watch: {
        accountSettings: {
            handler() {
                this.areEnabled();
            }
        },
    },
    methods: {
        //On-click eventhandler
        detailsDraw(event) {
            console.log(event);
            //Need to throw event back to app.vue 
            this.$emit('drawer', true);

        },
        updateDrawer(event) {
            console.log(event);
            //Need to throw event back to app.vue 
            this.$emit('drawer', true);

        },
        areEnabled() {
            console.log("navbar: ", this.accountSettings.Notifications)
            if (this.accountSettings.notifications)
                this.enableNotifications = true;
            if (this.accountSettings.takePayment)
                this.enableQrcode = true;
        },
        goToHome() {
            this.$router.push({ path: '/' });
        },
        goToMyaccount() {
            this.$router.push({ path: '/MyAccount' });
        },
        goToNotifications() {
            this.$router.push({ path: '/notifications' });
        },
        goToTakePayment() {
            this.$router.push({ path: '/TakePayment' });
        },
        switchMode() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
            localStorage.setItem('darkMode', this.$vuetify.theme.dark);
        },
    },
}
</script>

<style scoped>
.counter {
    position: absolute;
    margin-right: -35px;
    margin-top: -22px;
    background-color: red;
    color: #fff;
    padding: 1px 3px;
    font-size: 11px;
    z-index: 2;
    -webkit-border-radius: 10rem;
    -moz-border-radius: 10rem;
    -ms-border-radius: 10rem;
    -o-border-radius: 10rem;
    border-radius: 10rem;
}
</style>